<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择往来单位"
    clearable
    filterable
  >
    <el-option
      v-for="item in correspondentsList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'CorrespondentsLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      correspondentsList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      // 返回选中对象的完整信息（包含id和name）
      this.$emit('callBack', this.correspondentsList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchCorrespondentsList()
  },
  methods: {
    async fetchCorrespondentsList() {
      try {
        const res = await requestTicket.post('/Ticketing/correspondents/findAll')
        this.correspondentsList = res.data || []
      } catch (error) {
        console.error('获取往来单位列表失败:', error)
      }
    }
  }
}
</script>